import { compose } from 'ramda';
import { selectors } from '../state/channels';
import root from './root';

export default compose(
  selectors.channels,
  root.channels,
);
